<template>
  <div><zshc-Detail /></div>
</template>

<script>
import ZshcDetail from '@/components/zshcRequest/zshc.vue'

export default {
  name: 'Zshc',
  components: {
    ZshcDetail
    // sideMenu,
    // Header
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
